import * as React from 'react';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import EventHandlingModalContainer from '../EventHandlingModal/EventHandlingModalContainer';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import Constants from '../../globals/Constants';
import CommentModel from '../../types/CommentModel';
import ModalEventHandlersModel from '../../types/ModalEventHandlers';

export default class DeleteReviewModal extends React.Component<DeleteReviewModalProps, DeleteReviewModalState> {
   readonly state: DeleteReviewModalState = {hasFetchedComments: false, reviewComments: [], downloadingCsv: false};

   constructor(props: DeleteReviewModalProps) {
      super(props);
      autoBind(this);
   }

   async onDownloadCsv() {
      const {modalEventHandlers} = this.props;

      this.setState({downloadingCsv: true});
      await modalEventHandlers.onCustomEvent('downloadArchiveCsv', {gaEventName: Constants.googleAnalytics.exportComments.actions.exportFromDeleteModal});
      this.setState({downloadingCsv: false});
   }

   render() {
      const {onClose, reviewHasComments} = this.props;
      const {downloadingCsv} = this.state;

      const downloadReviewComments = (<span>
         <p>{Strings.labels.downloadReviewDataText}</p>
         <ControlButton buttonType={TscButtonType.primary}
                        label={downloadingCsv ? Strings.labels.downloadReviewDataButtonDisabledText : Strings.labels.downloadReviewDataButtonText}
                        isFullWidth={true}
                        disabled={downloadingCsv}
                        onClick={this.onDownloadCsv}
                        testId="delete-review-modal-download-csv-button" />
      </span>);

      return (
         <EventHandlingModalContainer visible={true}
                                      defaultOnClose={onClose}
                                      title={Strings.labels.deleteReview}
                                      closeContent={Strings.labels.cancel}
                                      confirmContent={Strings.labels.delete}
                                      confirmButtonType={TscButtonType.destructive}
                                      dismissContent={Strings.labels.cancel}
                                      testId="delete-review-modal">
            {Strings.labels.confirmDeletionText}
            {reviewHasComments && downloadReviewComments}
         </EventHandlingModalContainer>
      );
   }
}

export interface DeleteReviewModalProps {
   reviewHasComments: boolean;
   modalEventHandlers: ModalEventHandlersModel;
   onClose(): void;
}

export interface DeleteReviewModalState {
   hasFetchedComments: boolean;
   reviewComments: CommentModel[];
   downloadingCsv: boolean;
}
